import { RefObject } from "react";

export function useScrollToRef() {
  const scrollTo = (ref, offset) => {
    if (ref.current) {
      const top =
        ref.current.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({
        top,
        behavior: "smooth",
      });
    }
  };

  return scrollTo;
}
